module.exports = __webpack_public_path__ + "static/media/yginteriors.b4a5c0ef.png";